var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";

import { Grid, Table, TableHeaderRow } from "@devexpress/dx-react-grid-material-ui";
import { EditingState } from "@devexpress/dx-react-grid";
import { DataTypeProvider } from "@devexpress/dx-react-grid";

import { withStyles } from "@material-ui/styles";

var tableEditableWidgetStyles = function tableEditableWidgetStyles() {
  return {
    container: {
      overflowX: "auto"
    }
  };
};

var getRowId = function getRowId(row) {
  return row.index;
};

var TableEditableWidget = (_temp = _class = function (_Component) {
  _inherits(TableEditableWidget, _Component);

  function TableEditableWidget(props) {
    _classCallCheck(this, TableEditableWidget);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var value = props.formData || [];

    value.map(function (item, index) {
      return item.index = index;
    });

    _this.state = {
      tableLines: value
    };
    return _this;
  }

  TableEditableWidget.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        schema = _props.schema;
    var tableLines = this.state.tableLines;


    var columns = this.configureColumns(schema);

    return React.createElement(
      "section",
      null,
      React.createElement(
        FormControl,
        { component: "fieldset" },
        React.createElement(
          FormLabel,
          { component: "legend", style: { padding: "6px 0 7px" } },
          schema.metadata.title
        )
      ),
      React.createElement(
        FormGroup,
        { className: classes.container },
        React.createElement(
          Paper,
          null,
          React.createElement(
            Grid,
            { rows: tableLines, columns: columns, getRowId: getRowId },
            React.createElement(DataTypeProvider, {
              formatterComponent: this.SelectFormatter,
              "for": this.getSelectColumns()
            }),
            React.createElement(EditingState, { onCommitChanges: this.commitChanges }),
            React.createElement(Table, { messages: { noData: "Sem dados" } }),
            React.createElement(TableHeaderRow, null)
          )
        )
      )
    );
  };

  return TableEditableWidget;
}(Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getSelectColumns = function () {
    var elements = _this2.props.schema.elements;


    var selectColumns = [];

    elements.forEach(function (element) {
      if (element.type === "select") selectColumns.push(element.key);
    });

    return selectColumns;
  };

  this.configureColumns = function (_ref) {
    var elements = _ref.elements;

    return elements.reduce(function (acc, item) {
      var name = item.key,
          title = item.title;

      return [].concat(acc, [{ name: name, title: title }]);
    }, []);
  };

  this.commitChanges = function (_ref2) {
    var added = _ref2.added,
        changed = _ref2.changed,
        deleted = _ref2.deleted;

    var tableLines = _this2.state.tableLines.slice();
    if (changed) {
      Object.keys(changed).map(function (index) {
        if (changed[index]) {
          Object.keys(changed[index]).map(function (key) {
            return tableLines[index][key] = changed[index][key];
          });
        }
      });
    }

    if (deleted) {
      deleted.map(function (index) {
        return tableLines.splice(index, 1);
      });
    }

    if (added) {
      added.map(function (item) {
        return tableLines.push(item);
      });
    }

    tableLines.map(function (item, index) {
      return item.index = index;
    });

    _this2.props.onChange(tableLines);
    _this2.setState({ tableLines: tableLines });
  };

  this.EditCell = function (props) {
    var _props2 = _this2.props,
        elements = _props2.schema.elements,
        uiSchema = _props2.uiSchema;


    var columnElement = elements.find(function (element) {
      return element.key === props.column.name;
    });

    var Component = commandComponents[columnElement.type];

    return Component ? React.createElement(
      "td",
      null,
      React.createElement(Component, {
        element: columnElement,
        options: uiSchema["ui:options"],
        gridProperties: props
      })
    ) : null;
  };

  this.getElementValueByKey = function (element, props) {
    return element.titleMap.find(function (tm) {
      return props.value && tm.value === props.value.toString();
    });
  };

  this.SelectFormatter = function (props) {
    var schema = _this2.props.schema;


    var el = undefined;

    schema.elements.forEach(function (element) {
      if (props.column.name === element.key) {
        var foundElement = _this2.getElementValueByKey(element, props);
        el = foundElement ? foundElement.name : null;
      }
    });

    return React.createElement(
      "span",
      null,
      el
    );
  };
}, _temp);


TableEditableWidget.defaultProps = {
  value: []
};

export default withStyles(tableEditableWidgetStyles)(TableEditableWidget);